import { useEffect, useRef } from 'react';
import { PaginatedListRefType } from '@frontend/components';
import { useQuickFillCustomEventListener } from '../../hooks';

export const useScrollToTopOnNewPerson = (firstPersonId: string | undefined) => {
  const paginatedListRef = useRef<PaginatedListRefType>(null);
  const newPersonIdRef = useRef<string>();

  useQuickFillCustomEventListener('quick-fill:person-added', ({ personId }) => {
    newPersonIdRef.current = personId;
  });

  useEffect(() => {
    // scroll to top of list when new person is added to list
    if (newPersonIdRef.current === firstPersonId) {
      paginatedListRef.current?.scrollToTop();
    }
  }, [firstPersonId]);

  return { paginatedListRef, newPersonIdRef };
};
